import React from 'react'

const Futuristic = () => {
  return (
    <div>Futuristic</div>
  )
}

export default Futuristic